import React, {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, WithChildren} from '../../../../helpers'
import MenuIcon from "src/components/MenuIcon";

type Props = {
    to: string
    title: string
    hasBullet?: boolean
    disabled?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
                                                       children,
                                                       to,
                                                       title,
                                                       hasBullet = false,
                                                       disabled = false,
                                                   }) => {
    const {pathname} = useLocation()
    const isActive = checkIsActive(pathname, to)

    return (
        disabled ?
            <div className={"SideBarMenuHeader"}>
                {title}
            </div> :
            <div className={clsx('SideBarMenuItem', {active: isActive})}>
                <Link data-kt-menu-trigger='click'
                      className={clsx('w-full flex justify-between items-center', {active: isActive})} to={to}>
                    <div className={"pl-4 w-full flex gap-2 items-center"}>
                        <MenuIcon menu={title} color={isActive ? "#7E50EA" : "#8185A8"} size={"18"}/>
                        {hasBullet && (
                            <span className='menu-bullet'>
                                <span className='bullet bullet-dot'></span>
                            </span>
                        )}
                        <span className={clsx('SideBarItem', {active: isActive})}>{title}</span>
                    </div>
                </Link>
                {children}
            </div>
    )
}

export {SidebarMenuItem}
